// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WtTA","newExpiryDate":"styles_newExpiryDate__1h4mu","footer":"styles_footer__3ss3v"};